module.exports = __webpack_public_path__ + "static/media/userOnRTV.7988dddf.jpg";